import { IndexEntity } from "@omni/types/api/search/algolia/shared/enum/indexEntity.enum";
import { IndexSort } from "@omni/types/api/search/algolia/shared/enum/indexSort.enum";
import { IndexType } from "@omni/types/api/search/algolia/shared/enum/indexType.enum";
import { BaseStore } from "@omni/types/enums/baseStore.enum";
import { Environment } from "@omni/types/enums/environment.enum";
import { Locale } from "@omni/types/enums/locale.enum";
import { getBaseStoreName } from "@omni/utils/baseStore.utils";

export const compileIndex = ({
    environment,
    baseStore,
    locale,
    indexEntity,
    indexSort,
    indexType
}: {
    environment: Environment;
    baseStore: BaseStore;
    locale: Locale;
    indexEntity: IndexEntity;
} & (
    | {
          indexSort: IndexSort;
          indexType?: undefined;
      }
    | {
          indexSort?: undefined;
          indexType: IndexType;
      }
    | {
          indexSort?: undefined;
          indexType?: undefined;
      }
)) => {
    const algoliaEnv =
        environment === Environment.Local ? Environment.Test : environment;
    const baseStoreName = getBaseStoreName(baseStore);

    const baseIndex = `${algoliaEnv}_${baseStoreName}_${indexEntity}_${locale}`;

    if (indexSort) {
        return `${baseIndex}_${indexSort}`;
    } else if (indexType) {
        return `${baseIndex}_${indexType}`;
    } else {
        return baseIndex;
    }
};
